<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="850"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ headerText }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">
        <div class="row">
          <div class="col-12 h-75px" v-if="!$store.getters.isClient">
            <v-autocomplete
              v-model="formData.warehouse_id"
              dense
              :label="$t('warehouse')"
              item-text="text"
              item-value="index"
              clearable
              outlined
              :items="serverData.warehouses"
              hide-no-data
              hide-selected
              :error-messages="warehouse_idErrors"
              @blur="$v.formData.warehouse_id.$touch()"
            />
          </div>

          <div class="col-12 col-md-6 h-75px">
            <v-autocomplete
              v-model="formData.weekday"
              :items="serverData.weekdays"
              item-text="text"
              item-value="index"
              :label="$t('weekday')"
              dense
              outlined
              clearable
              :error-messages="weekdayErrors"
              @blur="$v.formData.weekday.$touch()"
            />
          </div>

          <div class="col-12 col-md-6 h-75px">
            <v-autocomplete
              v-model="formData.slot_interval"
              :items="serverData.slot_intervals"
              item-text="text"
              item-value="index"
              :label="$t('slot_interval')"
              dense
              outlined
              clearable
              :error-messages="slot_intervalErrors"
              @blur="$v.formData.slot_interval.$touch()"
            />
          </div>

          <div class="mt-4 col-12">
            <TimeBlockBuilder
              :query="formData.time_blocks"
              :options="hours"
              :operators="minutes"
              ref="actionBuilder"
            />
          </div>
        </div>

        <div
          class="my-4 min-h-75px d-flex flex-grow-1 align-end justify-center"
        >
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetFormData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            {{ submitButtonText }}
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import swalAdded from "@/core/services/AlertServices/SwalAdded";
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";

import TimeBlockBuilder from "@/own/components/warehouseManagement/warehouseSlotConfig/timeBlockBuilder/TimeBlockBuilder.vue";
export default {
  name: "ActionsDialog",
  components: { TimeBlockBuilder },
  props: ["refresher", "pageLoader"],
  mixins: [validationMixin, fieldValueValidation],
  validations: {
    formData: {
      warehouse_id: { required },
      weekday: { required },
      slot_interval: { required },
    },
  },
  data: () => ({
    dialog: false,
    serverData: [],
    formData: {
      id: null,
      warehouse_id: null,
      weekday: null,
      slot_interval: null,
      time_blocks: [],
    },
  }),
  methods: {
    loadDataFromServer() {
      if (this.actionType) {
        let sendData = { id: this.$store.getters.getItemForAction.id };
        this.pageLoader(true);
        ApiService.post(
          "/warehouse_management/warehouse_slot_configurations/edit",
          sendData
        )
          .then(({ data }) => {
            this.serverData = data;
            this.formData = {
              ...data.selector,
              time_blocks: data.selector.time_blocks.map((item) => {
                const [startHour, startMinute] = item.start.split(":");
                const [endHour, endMinute] = item.end.split(":");
                return {
                  startHour: startHour.padStart(2, "0"),
                  startMinute: startMinute.padStart(2, "0"),
                  endHour: endHour.padStart(2, "0"),
                  endMinute: endMinute.padStart(2, "0"),
                };
              }),
            };
            this.pageLoader(false);
          })
          .catch(() => {
            this.dialog = false;
            this.pageLoader(false);
          });
      } else {
        this.pageLoader(true);
        // this.$store.commit(SET_RULES, []);
        ApiService.post(
          "/warehouse_management/warehouse_slot_configurations/create"
        )
          .then(({ data }) => {
            this.serverData = data;
            this.pageLoader(false);
          })
          .catch(() => {
            this.dialog = false;
            this.pageLoader(false);
          });
      }
    },
    toggleModal() {
      if (this.dialog) {
        this.resetFormData();
      } else {
        this.loadDataFromServer();
      }
      this.dialog = !this.dialog;
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      return errors;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let sendData = {
        ...this.formData,
        time_blocks: this.formData.time_blocks.map((item) => ({
          start: item.startHour + ":" + item.startMinute,
          end: item.endHour + ":" + item.endMinute,
        })),
      };

      let actionUrl = "store";
      if (this.actionType) actionUrl = "update";
      this.pageLoader(true);
      ApiService.post(
        `/warehouse_management/warehouse_slot_configurations/${actionUrl}`,
        sendData
      )
        .then(() => {
          if (this.actionType) swalEdited();
          else swalAdded();
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetFormData() {
      // this.entries = [];
      this.formData = {
        warehouse_id: null,
        weekday: null,
        slot_interval: null,
        time_blocks: [],
      };
    },
  },
  computed: {
    // Generate hours array: 08 to 18
    hours: function () {
      return Array.from({ length: 11 }, (_, i) => {
        const value = i + 8; // start from 8
        return {
          index: value,
          text: value.toString().padStart(2, "0"),
        };
      });
    },
    minutes: function () {
      // Generate minutes array: 00, 15, 30, 45
      return Array.from({ length: 4 }, (_, i) => {
        const value = i * 15;
        return {
          index: value,
          text: value.toString().padStart(2, "0"),
        };
      });
    },
    actionType: function () {
      return !!this.$store.getters.getItemForAction;
    },
    submitButtonText: function () {
      if (this.actionType) return "Update";
      else return "Submit";
    },
    headerText: function () {
      if (this.actionType) return "Edit Item";
      else return "Add New Item";
    },
    warehouse_idErrors: function () {
      return this.handleFormValidation("warehouse_id");
    },
    weekdayErrors: function () {
      return this.handleFormValidation("weekday");
    },
    slot_intervalErrors: function () {
      return this.handleFormValidation("slot_interval");
    },
    statusErrors: function () {
      return this.handleFormValidation("status");
    },
  },
};
</script>

<style>
.v-radio label {
  margin-bottom: 0;
}
</style>
